import { StoreEnhancer } from 'redux';

import { IAppStateContainer } from '@Reducers/index';

const doNothingEnhancer: StoreEnhancer<IAppStateContainer> = (args: any) => args;

// support for devtools extension
export const HAS_REDUX_DEVTOOLS = Boolean(window.__REDUX_DEVTOOLS_EXTENSION__);

export const devtoolsReduxEnhancer = HAS_REDUX_DEVTOOLS ? window.__REDUX_DEVTOOLS_EXTENSION__() : doNothingEnhancer;
